type CartVariation = {
  id?: number | string;
  couleur?: string | null;
  taille?: string | null;
  quantite?: number | string;
  prix?: number | string;
};

export function normalizeVariationValue(value?: string | null): string {
  if (value == null) return "";
  const normalized = String(value).trim();
  if (!normalized || normalized.toLowerCase() === "null") return "";
  return normalized;
}

export function isHexColor(value: string): boolean {
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(value.trim());
}

/** Au moins une variation possède une couleur renseignée (hex ou nom). */
export function hasDisplayableCouleur(
  variations?: Array<{ couleur?: string | null }> | null,
): boolean {
  if (!variations?.length) return false;
  return variations.some((v) => normalizeVariationValue(v.couleur) !== "");
}

/** Variations distinctes par couleur (couleurs vides exclues). */
export function getDistinctColorVariations<
  T extends { couleur?: string | null },
>(variations: T[]): T[] {
  return variations.filter(
    (value, index, self) =>
      normalizeVariationValue(value.couleur) !== "" &&
      self.findIndex(
        (v) =>
          normalizeVariationValue(v.couleur) ===
          normalizeVariationValue(value.couleur),
      ) === index,
  );
}

/** Libellé texte pour une variation panier (couleur nommée ou taille). */
export function formatCartVariationLabel(
  variation?: CartVariation | null,
): string {
  if (!variation) return "";

  const parts: string[] = [];
  const couleur = normalizeVariationValue(variation.couleur);
  const taille = normalizeVariationValue(variation.taille);

  if (couleur && !isHexColor(couleur)) parts.push(`Couleur : ${couleur}`);
  if (taille) parts.push(`Taille : ${taille}`);

  return parts.join(" · ");
}

export type { CartVariation };
